import gtagCookieConsent from './gtag-cookie-consent';

document.addEventListener('DOMContentLoaded', () => {
  gtagCookieConsent('H6N20SBSPX');

  /*
   * Add class when newsletter input is filled so that the label knows when to float over the input.
   * In future CSS :empty would work here. (:placeholder-shown would work but our input doesn't have a placeholder)
   */
  const formField = document.querySelector('.frm_form_field');
  formField.addEventListener('focusout', (e) => {
    e.target.value
      ? e.target.classList.add('not-blank')
      : e.target.classList.remove('not-blank');
  });
});
